// @flow
export { default } from './TagsTemplate';



// WEBPACK FOOTER //
// ./src/components/tags/TagsTemplate/index.js